<template>
  <Organization />
</template>

<script>
import Organization from '@/components/organization/Organization.vue'

export default {
  components: {
    Organization,
  },
}
</script>
